import { SyncOptions } from '../store/dbTypes'
import { db } from '../store/db'
import { formatISO } from 'date-fns'

export const MESSAGE_SEPARATOR = '---'
export const ERROR_GETTING_CONTENT = 'ERROR_GETTING_CONTENT'
export const FILE_READ_ERROR = 'FILE_READ_ERROR'
export const ERROR = 'ERROR'
export const WARNING = 'WARNING'

//============= The actual sync ===============
// Note: everything needs to be done by service worker - 'cos the PWA sync event may start at any time
export const syncWithRemote = async (): Promise<void> => {
  // Make sure we're up and running
  const currentAppStatus = await db.appStatus.get('Tripsheets')
  if (!currentAppStatus) return

  // Send signal to service worker
  if (!navigator.serviceWorker) {
    console.log('error - service worker is missing - likely needs a restart')
    return
  }
  await navigator.serviceWorker.ready
  const registration = await navigator.serviceWorker.getRegistration()
  if (!registration) {
    console.log(
      'error - service worker registration failed - likely needs a restart'
    )
    return
  }

  // Start the sync immediately using a message event to the serviceworker
  registration.active?.postMessage({ message: 'syncWithRemote' })
}
